import en from './en';
import ptBR from './ptBR';

const languages = {
  en: { label: 'English', flag: '🇺🇸', translations: en },
  'pt-BR': { label: 'Português (BR)', flag: '🇧🇷', translations: ptBR },
};

export { languages };
export default languages;
